import { CheckIcon } from "@chakra-ui/icons";
import React from "react";

const NoPaymentText: React.FC = () => {
  return (
    <div className="flex flex-row items-center justify-center gap-3 font-semibold text-center pb-1 text-sm">
      <CheckIcon boxSize={4} />
      No Payment Due Now
    </div>
  );
};

export default NoPaymentText;
